import { render, staticRenderFns } from "./jsjt.vue?vue&type=template&id=0cdd7c70&scoped=true"
import script from "./jsjt.vue?vue&type=script&lang=js"
export * from "./jsjt.vue?vue&type=script&lang=js"
import style0 from "./jsjt.vue?vue&type=style&index=0&id=0cdd7c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdd7c70",
  null
  
)

export default component.exports